// Saves partial state updates one at a time without losing any.
// A change made while a save is in flight is queued, not dropped: queued changes for
// the same id merge into one update (the latest value of each field wins, which is
// what applying the PATCHes in order would leave), and are sent when the in-flight
// save ends. A failed save goes to onError and the queue carries on.
// Pure (no React), so tests run it under node.
export function createCoalescedSaver(save, onError = () => {}) {
  let inFlight = false
  const pending = new Map() // id -> merged update, in the order ids were first queued

  async function drain() {
    inFlight = true
    try {
      while (pending.size) {
        const [id, update] = pending.entries().next().value
        pending.delete(id)
        try {
          await save(id, update)
        } catch (err) {
          onError(err, id, update)
        }
      }
    } finally {
      inFlight = false
    }
  }

  return function persist(id, update) {
    if (!id) return Promise.resolve()
    pending.set(id, { ...(pending.get(id) || {}), ...update })
    return inFlight ? Promise.resolve() : drain()
  }
}
